/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-unneeded-ternary */
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import React, { useState } from 'react';
import { createSearchParams, Link as RouterLink, useLocation, useNavigate, useParams } from 'react-router-dom';
// material
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Button,
  Card,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
// components
import {
  collection,
  deleteDoc,
  doc,
  getCountFromServer,
  getDoc,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore';

import { deepOrange } from '@mui/material/colors';
import { db } from '../../../../firebase.config';
import Iconify from '../../../../components/Iconify';
import { UserAuth } from '../../../../context/AuthContext';
import { Variables } from '../../../../context/VariableContext';
import PopulationFilters from '../../../../components/filters/contactFilters';
import CustomButton from '../../../../components/CustomButton';
import useApproxContactsCount from '../../../../components/filters/useApproxContactsCount';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

// eslint-disable-next-line react/prop-types
export default function FilterDrawer({ orgID }) {
  const { user, userData } = UserAuth();
  const location = useLocation(); // <- IMPORTANT
  const [events, setEvents] = React.useState([]);
  const { openDrawer, setOpenDrawer } = Variables();


  const [filters, setFilters] = useState({
    filterEvent: [],
    filterInterest: [],
    filterNbEvent: { min: '', max: '' },
    filterBillet: { min: '', max: '' },
    totalDepense: { min: '', max: '' },
    lastDateOrder: { before: null, after: null },
    filterNewsletter: null,
    filterNotif: null,
    filterAbonne: null,
    filterHist: null,
    start: null,
    end: null,
  });

  // events/types doivent être fetchés à l’extérieur (comme tu fais déjà)
  // const events = []; // tes docs Firestore d’événements
  const types = [];  // tes docs Firestore "types"
  const loadingEvents = false;
  const loadingTypes = false;


  React.useEffect(() => {
    (async () => {
      try {
        console.log(filters);
      } catch (error) {
        console.log('error');
      }
    })();
  }, [filters]);

  const navigate = useNavigate();

  const isEmptyFilters =
  (!filters.filterEvent || filters.filterEvent.length === 0) &&
  (!filters.filterInterest || filters.filterInterest.length === 0) &&
  (!filters.filterNbEvent?.min && !filters.filterNbEvent?.max) &&
  (!filters.filterBillet?.min && !filters.filterBillet?.max) &&
  (!filters.totalDepense?.min && !filters.totalDepense?.max) &&
  (!filters.lastDateOrder?.after && !filters.lastDateOrder?.before) &&
  (filters.filterNewsletter == null) &&
  (filters.filterNotif == null) &&
  (filters.filterAbonne == null) &&
  (!filters.filterHist);

  // utils/serializeFilters.js (ou dans ton composant)
  const buildQueryFromFilters = (f) => {
    const params = {};

    // tableaux
    if (Array.isArray(f.filterEvent) && f.filterEvent.length) {
      params.fe = f.filterEvent.join(',');         // ex: fe=EVT1,EVT2
    }
    if (Array.isArray(f.filterInterest) && f.filterInterest.length) {
      params.fi = f.filterInterest.join(',');      // ex: fi=Afro,Techno
    }

    // ranges (min/max) -> nbe (Nb Events), nbt (Nb Tickets), dep (Dépense)
    const addRange = (key, r) => {
      const min = r?.min;
      const max = r?.max;
      if (min !== '' && min != null) params[`${key}_min`] = String(min);
      if (max !== '' && max != null) params[`${key}_max`] = String(max);
    };
    addRange('nbe', f.filterNbEvent);   // nbe_min, nbe_max
    addRange('nbt', f.filterBillet);    // nbt_min, nbt_max
    addRange('dep', f.totalDepense);    // dep_min, dep_max

    // dates dernier achat
    if (f.lastDateOrder?.after) params.ldo_after = f.lastDateOrder.after;   // YYYY-MM-DD
    if (f.lastDateOrder?.before) params.ldo_before = f.lastDateOrder.before;

    // booléens
    const addBool = (key, v) => {
      if (v === true || v === false) params[key] = String(v);  // "true"/"false"
    };
    addBool('nl', f.filterNewsletter); // newsletter
    addBool('pn', f.filterNotif);      // push notif
    addBool('pf', f.filterAbonne);     // page follower

    // historique d'ajout
    if (f.filterHist) {
      params.hist = f.filterHist; // today|yesterday|last-7-days|...|custom
      if (f.filterHist === 'custom') {
        if (f.start) params.start = f.start; // YYYY-MM-DD
        if (f.end) params.end = f.end;
      }
    }

    return params;
  };

  const parseBool = (s) => s === 'true' ? true : s === 'false' ? false : null;
  const parseRange = (sp, key) => ({
    min: sp.get(`${key}_min`) ?? '',
    max: sp.get(`${key}_max`) ?? '',
  });

  const countEndpoint = 'https://us-central1-event-86cbf.cloudfunctions.net/contactApproxCountv2'; 
  // ou garde ton endpoint existant si tu veux, adapte le mapping du retour { approx: number }

  const { count, counfidence, loading: countLoading } = useApproxContactsCount(countEndpoint, orgID, filters, { debounceMs: 450 });


  const applyFilter = () => {
    const params = buildQueryFromFilters(filters);     // <— basé sur ton state `filters`
    navigate({
      pathname: '',                                    // ou la route de la liste
      search: `?${createSearchParams(params)}`,
    });
    setOpenDrawer(false);
  };

  const filtersFromSearch = (search) => {
    const sp = new URLSearchParams(search);
    const csv = (v) => (v ? v.split(',').filter(Boolean) : []);

    const hist = sp.get('hist');

    return {
      filterEvent: csv(sp.get('fe')),
      filterInterest: csv(sp.get('fi')),
      filterNbEvent: parseRange(sp, 'nbe'),
      filterBillet: parseRange(sp, 'nbt'),
      totalDepense: parseRange(sp, 'dep'),
      lastDateOrder: {
        after: sp.get('ldo_after') || null,
        before: sp.get('ldo_before') || null,
      },
      filterNewsletter: parseBool(sp.get('nl')),
      filterNotif: parseBool(sp.get('pn')),
      filterAbonne: parseBool(sp.get('pf')),
      filterHist: hist || null,
      start: hist === 'custom' ? (sp.get('start') || null) : null,
      end: hist === 'custom' ? (sp.get('end') || null) : null,
    };
  };
  const lastSearchRef = React.useRef('');
  React.useEffect(() => {
    (async () => {
      try {
        if (lastSearchRef.current !== location.search) {
          setFilters(filtersFromSearch(location.search));
          lastSearchRef.current = location.search;
        }
      } catch (error) {
        console.log('error');
      }
    })();
  }, [location.search]);

  React.useEffect(() => {
    (async () => {
      try {
        if (events.length === 0) {
                  setEvents([]);
                  const tmp = []
                  const q = query(
                      collection(db, 'evenement'),
                      where('orgId', '==', userData.idOrg),
                      orderBy('dateDebut', 'asc')
                  );
                  const querySnapshot = await getDocs(q);
                  // setEvents(querySnapshot.docs);
                  querySnapshot.forEach((d) => {
                      // sort list
                      const element = d;
                      tmp.push(element)
                  });
                  setEvents(tmp)
              }
      } catch (error) {
        console.log('error');
      }
    })();
  }, [userData]);



  return (
    <Box>
      <PopulationFilters
        value={filters}
        onChange={setFilters}
        events={events}
        types={types}
        title='Filtrer les contacts'
        loadingEvents={loadingEvents}
        loadingTypes={loadingTypes}
        sx={{ height: {xs:'82vh' , sm:'80vh', md: '80vh',lg: '82vh', xl: '83vh'} }}
      />
      {/** boutons next/ back */}
      <Stack direction='column' spacing={1} padding={1} justifyContent={'right'} alignItems={'end'} sx={{ borderTop: '1px solid gainsboro' }}>
        <Typography variant="body2" sx={{ mr: 1 }}>
            {(countLoading ? 'Calcul…' : (count != null ? `≈ ${count} contacts` : ''))}
          </Typography>
        <Stack direction='row' spacing={2}>
          <CustomButton loading={countLoading} buttonText={'Annuler'} type={'secondaire'} onClick={() => {
            setOpenDrawer(false);
          }} />
          <CustomButton loading={countLoading} disabled={isEmptyFilters} buttonText={'Afficher les contacts'} type={'primaire'} onClick={applyFilter} />
          
        </Stack>

      </Stack>
    </Box>
  );
}
